import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { UniversalPlayer } from '@/components/player/UniversalPlayer';
import { AudioProvider } from '@/contexts/AudioContext';

export function Layout() {
  return (
    <AudioProvider>
      <div className="min-h-screen flex flex-col">
        {/* Sticky header area - player + nav stay together when scrolling */}
        <div className="sticky top-0 z-50">
          <UniversalPlayer />
          <Header />
        </div>
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
    </AudioProvider>
  );
}
